import React from 'react'
import { Link } from 'react-router-dom'

import './MenuLink.css'

type Props = {
    className?: string
}

export const MenuPriceLink: React.FC<Props> = ({ className }) => {
    return (
        <Link
            to="/price"
            className={'menu_link ' + className}
            onClick={(e) =>
                className?.includes('opacity-0') && e.preventDefault()
            }
        >
            Стать клиентом
        </Link>
    )
}
